<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="titlepage" id="bk">
<h1 class="bk"><span aria-label="iii" class="page" id="piii" role="doc-pagebreak"></span>WRITING for SOCIAL SCIENTISTS</h1>
<h1 class="bk1">How to Start and Finish Your Thesis, Book, or Article</h1>
<h1 class="bk2">THIRD EDITION</h1>
<p class="bkau">Howard S. Becker</p>
<p class="bkau"><i>with a chapter by</i> PAMELA RICHARDS</p>
<h1 class="bk1"><img alt="" height="600" src="images/chi-becker-fig00001.jpeg" width="590"/></h1>
<p class="bkpub">The University of Chicago Press</p>
<p class="bkpub1">Chicago and London</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-becker-0004.vue?50edbb50